<div class="border-b border-edge">
  <nav class="-mb-px mx-4 sm:mx-0 flex space-x-8 overflow-x-auto" aria-label="Tabs">
    <ng-content></ng-content>
  </nav>
</div>
